import { Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import SvgImages from '../SvgImages';

interface SearchInputProps {
  children?: React.ReactNode,
  className?: string,
  onChangeHandler: (e: React.ChangeEvent<HTMLInputElement>) => void
}

const SearchInput = ({ children, onChangeHandler, className = "" } : SearchInputProps) => {
  const { t } = useTranslation();
  return (
    <Fragment>
      <div className={className}>
        <div className={"search-input-container position-relative"}>
          <SvgImages wrapperClassNames="search_icon" imgKey="search_icon" />
          <input
            placeholder={t("Labels.search")}
            onChange={onChangeHandler}
            className="input search-input w-100"
          />
        </div>
      </div>
      { children }
    </Fragment>
  )
}

export default SearchInput